import { render, staticRenderFns } from "./NewtonSecondLawViz.vue?vue&type=template&id=22ddd930&scoped=true"
import script from "./NewtonSecondLawViz.vue?vue&type=script&lang=js"
export * from "./NewtonSecondLawViz.vue?vue&type=script&lang=js"
import style0 from "./NewtonSecondLawViz.vue?vue&type=style&index=0&id=22ddd930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddd930",
  null
  
)

export default component.exports